<template>
	<div class="session-wrapper">
		<div class="session-center text-xs-center">
			<div class="session-table-cell">
				<div class="session-content">
					<img 
						:src="appLogo"
						class="img-responsive mb-3" 
						width="78" 
						height="78" 
					/>
					<h2 class="mb-3">{{$t('message.loginToAdmin')}}</h2>
					<p class="fs-14">{{$t('message.enterUsernameAndPasswordToAccessControlPanelOf')}} {{brand}}.</p>
					<v-form v-model="valid" class="mb-4">
						<v-text-field 
							label="Login account" 
							v-model="email" 
							required
						></v-text-field>
						<v-text-field 
							label="Password" 
							v-model="password" 
							type="password" 
							required
						></v-text-field>
						<div>
							<v-btn :disabled="disable" large @click="submit" block color="primary">{{$t('message.loginNow')}}</v-btn>
						</div>
						<p>{{$t('message.bySigningUpYouAgreeTo')}} {{brand}}</p>
						<router-link to="">{{$t('message.termsOfService')}}</router-link>
					</v-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import AppConfig from "Constants/AppConfig";


export default {
  components: {
	},
  data() {
    return {
      checkbox: false,
			valid: false,
			disable: false,
      email: '',
      password: '',
      appLogo: AppConfig.appLogo2,
      brand: AppConfig.brand
    };
	},
	mounted() {
		if(localStorage.useremail) this.email = localStorage.useremail;
		if(localStorage.userpassword) this.password = localStorage.userpassword;
		//console.log ("Login page");
	},
	watch: {
    email(newName) {
			localStorage.useremail = newName;
			this.disable = false;
		},
		password(newName) {
			localStorage.userpassword = newName;
			this.disable = false;
		}
  },
  methods: {
    submit() {
      const user = {
        email: this.email,
        password: this.password
			};
			this.disable = true;
      this.$store.dispatch("signinUserInPosworld", {
				user
			});
			
			setTimeout(() => {
        this.disable = false;
       }, 3500)
		}
  }
};

</script>
